<template>
    <div>
        <el-row class="tac">

            <el-col :xs="0" :sm="0" :md="4" :lg="4" :xl="4" style="box-shadow: 3px 0 3px #DDDDDD;">
              <el-menu
                  style="min-height:calc(100vh - 70px);"
                  background-color="#4f4f4f"
                  text-color="#ccc"
                  active-text-color="#fff"
                  :default-active="activeIndex"
                  @select="handleSelect"
              >

                <el-menu-item index="1" @click="currentComponent='cgvComponent'">{{buttons[0]}}</el-menu-item>
                <el-menu-item index="2" @click="currentComponent='calComponent'">{{buttons[1]}}</el-menu-item>
                <el-menu-item index="3" @click="currentComponent='caeComponent'">{{buttons[2]}}</el-menu-item>
                <el-menu-item index="4" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='计算磁芯等效参数'">計算磁芯的等效參數</el-menu-item>
                    <el-menu-item index="5" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='计算磁芯的磁导率和AL'">計算磁芯的磁導率和AL</el-menu-item>
                    <el-menu-item index="6" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='已知磁导率计算一定匝数时电感'">已知磁導率計算一定匝數時電感</el-menu-item>
                    <el-menu-item index="7" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='已知磁导率计算一定电感时的匝数'">已知磁導率計算一定電感時的匝數</el-menu-item>
                    <el-menu-item index="8" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='计算磁芯的输出功率'">計算磁芯的輸出功率</el-menu-item>
                    <el-menu-item index="9" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='计算磁芯的重量'">計算磁芯的重量</el-menu-item>
                    <el-menu-item index="10" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='计算磁芯的气隙和电感'">計算磁芯的气隙和电感</el-menu-item>
                    <el-menu-item index="11" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='计算磁芯的密度'">計算磁芯的密度</el-menu-item>



                </el-menu>



            </el-col>
          <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="contain" style="height: 90vh;">
            <component :is="currentComponent" :message="dynamicMessage" ref="calculateComponent" @changeMsg="changes"></component>
          </el-col>
        </el-row>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import cgvComponent from "@/Cht/forIfcores/search/CoreCalculations/cgvComponent.vue";
    import calComponent from "@/Cht/forIfcores/search/CoreCalculations/calComponent.vue";
    import caeComponent from "@/Cht/forIfcores/search/CoreCalculations/caeComponent.vue";
    import CalculateEquivalentParameters
      from "@/Cht/forIfcores/search/CoreCalculations/CalculateEquivalentParameters.vue";

    export default {
        name: "search",
      components: {
        cgvComponent,
        calComponent,
        caeComponent,
        CalculateEquivalentParameters
      },
        data(){
            return{
                path:this.$route.path,//设置菜单高亮
                form:{chuangkou:0.4},
                al:{},
                ae:{},
                titles:["按輸出功率查詢合格的堆芯信息", "按AL查詢", "按Ae查詢"],
                labels:["頻率","電流密度","窗口填充係數", "磁通密度","功率最小","功率最大", "AL最小值","Ae 最小值","AL 最大值","Ae 最大值"],
                placeholders:["頻率單位:KHz","單位:A/mm²Max 4A/mm²",
                    "單位:KW常用0.4","單位:T 1T=1000mT", "單位:W","單位:W", "大於0，全部寫0 ",
                    "大於這個，全部寫0 ", "搜索大於或等於這個值的AL ",
                    "搜索小於或等於這個值的AL ", "搜索Ae大於或等於這個值", "搜索Ae小於等於這個值",
                ],
                buttons:["輸出功率查詢","按AL查詢","按Ae查詢",
                    "正激拓拔","全橋推拉","關閉","提交"],
                tableData:null,
                tableData2:null,
                Categories:null,
                loading:false,
                gv: true,
                aldiv:false,
                aediv:false,
                isPC:'true',
              currentComponent: 'cgvComponent', // 初始值应为字符串
              isPhone: "",
              dynamicMessage: null,
              someBooleanValue: false,
              activeIndex: '1'

            }
        }
        ,methods:{

        handleSelect(index) {
          this.activeIndex = index;
        },
        callChildMethod() {
          this.$nextTick(() => {
            if (this.$refs.calculateComponent && typeof this.$refs.calculateComponent.changeIsShow === 'function') {
              this.$refs.calculateComponent.changeIsShow();
            } else {
              console.error('changeIsShow 方法未找到');
            }
          });
        },
        changes(data){
          this.$emit('changeMsg', data)
        },

            guanbi(){
                this.$emit('changeMsg', true)
            },
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            }
        },
        created() {
            if (this._isMobile()) {
                if(this._isMobile().indexOf("iPad")!=-1){
                    this.isPC=true;
                }else {
                    this.isPC=false;
                }

            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC=true;
            }
        },

    }
</script>

<style scoped>
a{
  text-decoration:underline ;
  color: #409EFF;
  cursor: pointer;
  display: inline-block;
  width: 90px;
  text-align: center;
  line-height: 30px;
  margin-left: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-bottom: 5px;
}
.tac{
  height: calc(100vh - 70px);
  z-index: 999;
  border-top:1px solid #cccccc ;
}
/*html{*/
/*    !*隐藏滚动条，当IE下溢出，仍然可以滚动*!*/
/*    -ms-overflow-style:none;*/
/*    !*火狐下隐藏滚动条*!*/
/*    overflow:-moz-scrollbars-none;*/
/*}*/


/*::-webkit-scrollbar{*/
/*    display:none;*/
/*}*/

.demo-image .block {
  padding: 10px 0;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}
/* 隐藏 x 轴滚动条 */
.contain {
  overflow-x: scroll; /* 启用 x 轴滚动 */
  overflow-y: auto; /* 启用 y 轴滚动 */
}

/* Chrome, Safari 和 Opera */
.contain::-webkit-scrollbar {
  width: 12px; /* 设置滚动条宽度 */
}

.contain::-webkit-scrollbar:horizontal {
  display: none; /* 隐藏 x 轴滚动条 */
}

/* Firefox */
.contain {
  scrollbar-width: thin; /* 设置滚动条宽度 */
}

.contain {
  scrollbar-color: transparent; /* 隐藏 x 轴滚动条 */
}

/* IE 和 Edge */
.contain {
  -ms-overflow-style: -ms-autohiding-scrollbar; /* 仅隐藏 x 轴滚动条 */
}


</style>




